import React from "react";
import {useDispatch, useSelector} from "react-redux";
import { Modal, ModalHeader, ModalContent, ModalFooter, Notification, Button, StyledLink, Text } from "@netapp/bxp-design-system-react";
import { useTranslation } from 'react-i18next';
import { appComponents as i18nNamespace } from '../../../i18n/namespace';

export default () => {
    const dispatch = useDispatch();
    const { t } = useTranslation(i18nNamespace);
    const selectedAgentId = useSelector(state => state.tenancy.selectedAgentId);

    const discardChangeAgentDialog = () => {
        dispatch({
            type: 'TENANCY:DISCARD-CHANGE-AGENT-MESSAGE'
        })
    };

    const openConnectorMenu = () => {
        discardChangeAgentDialog();

        dispatch({
            type: 'MENU:OPEN-WIDGET',
            payload: 'connectors'
        });
    };

    return <Modal>
        <ModalHeader>
            {t("inactive_connector")}
        </ModalHeader>
        <ModalContent>
            <Notification type="error" style={{marginBottom: 35}}>
               {t("connector_inactive_error")}
            </Notification>
            {selectedAgentId && <>
                <Text>{t("check_network_connectivity")}</Text>
                <Text>{t("switched_to_active_connector")}</Text>
            </>}
            {!selectedAgentId && <Text>{t("check_and_create_new_connector")}</Text>}
        </ModalContent>
        <ModalFooter>
            {selectedAgentId && <Button onClick={openConnectorMenu}>{t("switch_bluexp_connectors")}</Button>}
            {!selectedAgentId && <StyledLink to={location => ({...location, hash: "addConnector"})} onClick={discardChangeAgentDialog}>{t("create_connector")}</StyledLink>}
            <Button color="secondary" onClick={discardChangeAgentDialog}>{t("close")}</Button>
        </ModalFooter>
    </Modal>;
};
